export default {
  state: {
    isVisible: false,
    text: '',
    html: '',
    color: '', // [ 'success', 'info', 'warning', 'error' ]
    timeout: 0
  },
  getters: {
    getSnackBarColor(state) {
      return state.color
    },
    getSnackBarTimeout(state) {
      return state.timeout
    },
    getSnackBarText(state) {
      // DEV-11545: text can be a function, re-run on display, so a message raised before the
      // store's language is applied (e.g. on reload) still follows the language switch
      return typeof state.text === 'function' ? state.text() : state.text
    },
    getSnackBarHtml(state) {
      return state.html
    }
  },
  actions: {
    showSnack({ state, commit }, data) {
      commit('SHOW_SNACK', data)
    }
  },
  mutations: {
    UPDATE_VISIBILITY(state, val) {
      state.isVisible = !!val
    },
    SHOW_SNACK(state, data) {
      if (data.text) {
        state.text = data.text
        state.color = data.color
        state.timeout = 'timeout' in data ? data.timeout : 8000
        state.isVisible = true
      }
    }
  }
}
